import type { FC } from 'react'

import { InfoOutline16, Popover, PopoverTrigger } from '@sok/design-system'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const SumChangeInfo: FC = () => (
  <Popover
    getPopupContainer={(container) => container}
    trigger={PopoverTrigger.HOVER}
    content={<SumChangePopover />}
  >
    <InfoIconWrapper data-test-id="sum-change-icon">
      <InfoOutline16 />
    </InfoIconWrapper>
  </Popover>
)

const InfoIconWrapper = styled.div(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  paddingLeft: theme.spacings.xSmall,
  paddingRight: theme.spacings.xSmall,
  svg: {
    color: theme.colors.primary,
  },

  ['&:hover']: {
    svg: {
      color: theme.colors.primary,
    },
  },
}))

const _SumChangePopover: FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation()
  return (
    <div className={className} data-test-id="sum-change-popover">
      <p>{t('Estimated price disclaimer')}</p>
    </div>
  )
}

const SumChangePopover = styled(_SumChangePopover)({
  textAlign: 'left',
  p: {
    marginBottom: 0,
  },
})
